const biRewardsApi = require('services/api/beautyInsider');
const UtilActions = require('utils/redux/Actions');

function fetchBiRewards() {
    return dispatch => {
        biRewardsApi
            .getBiRewardsGroupForProfile()
            .then(data => {
                const { biRewardGroups } = data;
                dispatch(UtilActions.merge('beautyInsider', 'biRewardGroups', biRewardGroups));
            })
            // eslint-disable-next-line no-console
            .catch(console.error);
    };
}

module.exports = { fetchBiRewards };
